import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PackageFaqItem from '~/pages/Packages/PackageFaqItem';
import { PackageFaqType } from '~/types/packagesType';

export default function PackagesFaqSection({
  faqs,
  isLoading,
}: {
  faqs: PackageFaqType[];
  isLoading: boolean;
}) {
  const { t } = useTranslation('app');
  const [openFaqId, setOpenFaqId] = useState<number | null>(
    faqs[0]?.id ?? null,
  );

  useEffect(() => {
    setOpenFaqId(faqs[0]?.id ?? null);
  }, [faqs]);

  if (isLoading) {
    return (
      <section
        className="w-full"
        style={{ backgroundColor: 'rgba(245, 245, 245, 0.6)' }}
      >
        <div className="layout-boundary py-5x md:py-10x">
          <div className="layout-boundary__inner flex w-full flex-col gap-3x md:flex-row md:gap-8x px-2x md:px-0">
            <div className="w-full md:max-w-[197px] md:pt-3x">
              <div className="h-[39px] w-[160px] animate-pulse rounded-[8px] bg-gray_light_1" />
            </div>
            <div className="w-full md:flex-1">
              {Array.from({ length: 2 }).map((_, index) => (
                <div
                  key={`faq-skeleton-${index}`}
                  className=" px-2x py-3x md:px-2x md:py-3x"
                >
                  <div className="flex w-full items-start justify-between gap-2x">
                    <div className="h-[24px] flex-1 animate-pulse rounded-[8px] bg-gray_light_1" />
                    <div className="size-[24px] shrink-0 animate-pulse rounded-full bg-gray_light_1" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (!faqs.length) return null;

  return (
    <section
      className="w-full"
      style={{ backgroundColor: 'rgba(245, 245, 245, 0.6)' }}
    >
      <div className="layout-boundary py-4x md:py-10x">
        <div className="layout-boundary__inner flex w-full flex-col gap-3x md:flex-row md:gap-8x px-2x md:px-0">
          <div className="w-full md:max-w-[197px] md:pt-3x">
            <p className="text-title-3 md:text-title-1 text-black">
              {t('faqsTitle')}
            </p>
          </div>
          <div className="w-full md:flex-1 ps-0 md:ps-5x">
            {faqs.map((faq) => (
              <PackageFaqItem
                key={faq.id}
                faq={faq}
                isFirstItem={faq.id === faqs[0]?.id}
                isOpen={openFaqId === faq.id}
                onClick={() =>
                  setOpenFaqId((currentId) =>
                    currentId === faq.id ? null : faq.id,
                  )
                }
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
